import { useHydrated } from '@/features/shared/components/ClientOnly'
import { BREAKPOINTS } from '@shipt/design-system-themes'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import {
  dismissAppBanner,
  getOpenTheAppBannerVariant,
  isAppBannerDismissed,
} from '@/features/shared/components/AppBanners/utils'

const DynamicOpenTheAppDialog = dynamic(
  async () =>
    (await import('@/features/shared/components/AppBanners/OpenTheAppDialog')).OpenTheAppDialog,
  { ssr: false },
)

export const OpenTheAppDialogContainer = () => {
  const [isDismissedInSession, setIsDismissedInSession] = useState(false)
  const pathname = usePathname() ?? ''
  const isPage = useIsPage()
  const hydrated = useHydrated()

  const shouldShowVariant = getOpenTheAppBannerVariant(isPage, pathname, 'drawer')

  const isDismissed = isDismissedInSession || isAppBannerDismissed()

  if (!hydrated || window.innerWidth > BREAKPOINTS.SMALL || !shouldShowVariant || isDismissed) {
    return null
  }

  const dismissDialog = () => {
    setIsDismissedInSession(true)
    dismissAppBanner()
    document.body.style.overflow = ''
  }

  return <DynamicOpenTheAppDialog dismissDialog={dismissDialog} />
}
